import React, { useEffect, useState, useRef } from 'react'
import { Text, View, StyleSheet, FlatList, TouchableOpacity, Image, ScrollView, Platform, Animated } from 'react-native'
import { EvilIcons, Feather, Ionicons } from '@expo/vector-icons'
import { CourseItem } from './CourseItem'
import { LEARNING_STATUS } from './constants'
import { get_category_by_id, update_status_local_category, get_course_by_id, update_course_local } from '../../db/learning'
import { openDB } from '../../db/indexDB'
import theme from '../../../theme'
import styles from './CategoryItemStyles'
import { getLanguage } from '../appBar/context/LocalizationContext'
import RenderHTML from 'react-native-render-html'
import { useWindowDimensions } from 'react-native'
import { placeholderGeneral } from '../customUtils/Constants'
import { useDimensionsStore } from '@/redux/zustand/useDimensionStore'

const isWeb = Platform.OS === 'web'

const CategoryItem = ({ data, categories, reload, single, isMobile }) => {
    const { width: winWidth } = useWindowDimensions()
    const { category_name, description, _id, repository, cover_image, status, blocked_by } = data
    
    const deepCopyRepository = (repo) => {
        if (!Array.isArray(repo)) return []
        return repo.map(course => ({...course})).sort((a, b) => a.course_index - b.course_index)
    }
    
    const [allrepository, setRepository] = useState(deepCopyRepository(repository))
    const [item, setItem] = useState({
        _id: data?._id,
        category_name: data?.category_name,
        description: data?.description,
        repository: data?.repository,
        cover_image: data?.cover_image,
        status: data?.status,
        blocked_by: data?.blocked_by,
    })

    const verify_is_complete = async () => {
        try {
            const database = await openDB()
            if (item && item.status !== undefined && item.status !== LEARNING_STATUS.COMPLETED) {
                if (item.status === LEARNING_STATUS.PENDIENTE) {
                    // Si el estado es pendiente, verifico si todos los cursos están aprobados
                    const areAllCoursesApproved = allrepository.every((curso) => curso.status === LEARNING_STATUS.COMPLETED)
                    if (areAllCoursesApproved) {
                        // Si todos los cursos están aprobados, paso la categoría a status 3
                        console.log(`🟢 Paso la categoría ${item.category_name} a status 3`)
                        const payload = [
                            {
                                category: item,
                                status: LEARNING_STATUS.COMPLETED,
                            },
                        ]
                        await update_status_local_category(payload)
                    } else {
                        // Si no todos los cursos están aprobados, no hago nada
                        // busco si tienen cursos con blocked_by
                        let find_courses_blocked = allrepository.filter((course) => course.blocked_by && course.blocked_by.length > 0)
                        if (find_courses_blocked.length > 0) {
                            for (let i = 0; i < find_courses_blocked.length; i++) {
                                const locked_course = find_courses_blocked[i] // curso bloqueado
                                for (let j = 0; j < locked_course.blocked_by.length; j++) {
                                    const blocking_course = locked_course.blocked_by[j]
                                    //verifico si el curso que me bloquea  está completo
                                    // aca busco el curso en la tabla
                                    const find_blocking_course = await get_course_by_id(database, blocking_course)
                                    if (find_blocking_course) {
                                        if (
                                            find_blocking_course['status'] === LEARNING_STATUS.COMPLETED &&
                                            locked_course['status'] === LEARNING_STATUS.BLOCKED
                                        ) {
                                            // encuentro el curso gen de ventas que esta completo que

                                            await update_course_local(database, locked_course['_id'], LEARNING_STATUS.PENDIENTE)
                                            let index_course = allrepository.findIndex((c) => c._id === locked_course._id)

                                            setRepository((prevState) => {
                                                let newRepository = [...prevState]
                                                // Crear copia del objeto curso en lugar de mutarlo directamente
                                                newRepository[index_course] = {...newRepository[index_course], status: LEARNING_STATUS.PENDIENTE}
                                                return newRepository
                                            })

                                            // count_approved++
                                        } else {
                                            // console.log('el curso que bloquea no esta completo')
                                        }
                                    }
                                }

                                // if (count_approved === locked_course.blocked_by.length) {
                                //     let update_course = await update_course_local(database, locked_course['_id'], LEARNING_STATUS.PENDIENTE)
                                //     let index_course = cursos.findIndex((c) => c._id == locked_course._id)
                                //     if (index_course != -1) {
                                //         cursos[index_course]['status'] = LEARNING_STATUS.PENDIENTE
                                //         setRepository(cursos)
                                //     }
                                // }
                            }
                        }
                    }
                } else {
                    if (item.status == LEARNING_STATUS.BLOCKED) {
                        // Verifico quién me bloquea
                        for (const id of item.blocked_by) {
                            const database = await openDB()
                            const blockingCategory = await get_category_by_id(database, id)

                            if (blockingCategory.status === LEARNING_STATUS.COMPLETED) {
                                // Si el que me bloquea está en status 3, me desbloqueo y paso a status 1
                                console.log(`Desbloqueo ${item.category_name} porque ${blockingCategory.category_name} está completada.`)
                                const payload = [
                                    {
                                        category: item,
                                        status: LEARNING_STATUS.PENDIENTE,
                                    },
                                ]
                                await update_status_local_category(payload)
                                setItem((prevCategory) => ({
                                    ...prevCategory,
                                    status: LEARNING_STATUS.PENDIENTE,
                                }))
                            } else if (blockingCategory.status === LEARNING_STATUS.PENDIENTE) {
                                // Si la categoría que me bloquea está pendiente, reviso nuevamente si tiene todos los cursos completos
                                const areAllCoursesCompleted = blockingCategory.repository.every(
                                    (curso) => curso.status === LEARNING_STATUS.COMPLETED,
                                )

                                if (areAllCoursesCompleted) {
                                    // Si todos los cursos de la categoría bloqueadora están completados, actualizo esa categoría a status 3 y me desbloqueo
                                    console.log(
                                        `Desbloqueo ${item.category_name} porque ${blockingCategory.category_name} tiene todos los cursos completados.`,
                                    )
                                    const payload = [
                                        {
                                            category: blockingCategory,
                                            status: LEARNING_STATUS.COMPLETED,
                                        },
                                        {
                                            category: item,
                                            status: LEARNING_STATUS.PENDIENTE,
                                        },
                                    ]
                                    await update_status_local_category(payload)
                                    setItem((prevCategory) => ({
                                        ...prevCategory,
                                        status: LEARNING_STATUS.PENDIENTE,
                                    }))
                                }
                            }
                        }
                    }
                }
            }
        } catch (error) {
            console.log('🚀 ~ verify_is_complete ~ error:', error)
            console.error(error)
        }
    }

    // Cuando cambian los datos de la categoría o llega un reload, sincronizar el repositorio local
    useEffect(() => {
        try {
            // Hacer copia profunda del nuevo repository para evitar mutaciones
            const freshCopy = Array.isArray(repository) 
                ? repository.map(course => ({...course})).sort((a, b) => a.course_index - b.course_index)
                : []
            setRepository(freshCopy)
        } catch {}
    }, [repository, reload])
    // console.log('DaTA DE CATEGORY ITEM:', data?.category_name, '===> courses ', data?.repository)
    useEffect(() => {
        setItem({
            _id: data?._id,
            category_name: data?.category_name,
            description: data?.description,
            repository: data?.repository,
            cover_image: data?.cover_image,
            status: data?.status,
            blocked_by: data?.blocked_by,
        })
        verify_is_complete()
    }, [reload, data])

    const isCategoryBlocked = item?.status === LEARNING_STATUS.BLOCKED

    const handle_category = async () => {
        console.log(`categoria: ${item.category_name} -- STATUS: ${item.status}`)

        let next_category = find_next_category(item, categories)
        console.log('🚀 ~ consthandle_category= ~ next_category:', next_category.category_name)
    }

    const find_next_category = (current_category, array_categories) => {
        const current_index = array_categories.findIndex((category) => category._id.toString() === current_category._id.toString())

        if (current_index === -1 || current_index === array_categories.length - 1) {
            return null
        }

        return array_categories[current_index + 1]
    }

    const [isExpanded, setIsExpanded] = useState(false)
    const [showReadMore, setShowReadMore] = useState(false)
    const { languageFile } = getLanguage()

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded)
    }
    useEffect(() => {
        if (item?.description && item?.description.length > 140) {
            setShowReadMore(true)
        }
    }, [item?.description])

    const ITEM_WIDTH = 508
    const flatListRef = useRef(null)

    const [currentIndex, setCurrentIndex] = useState(0)
    const scrollX = useRef(new Animated.Value(0)).current
    const [atEnd, setAtEnd] = useState(false)
    const [atStart, setAtStart] = useState(true)
    const scrollOffset = useRef(0)

    const onScroll = Animated.event([{ nativeEvent: { contentOffset: { x: scrollX } } }], {
        useNativeDriver: false,
        listener: (e) => {
            const { contentOffset, contentSize, layoutMeasurement } = e.nativeEvent
            scrollOffset.current = contentOffset.x

            // Detecta índice actual aproximado
            const index = Math.round(contentOffset.x / ITEM_WIDTH)
            setCurrentIndex(index)

            // Detecta inicio/fin con tolerancia
            setAtStart(contentOffset.x <= 5)
            setAtEnd(contentOffset.x + layoutMeasurement.width >= contentSize.width - 5)
        },
    })
    const moveCarrousell = (forward = false) => {
        if (!flatListRef.current) return

        const newIndex = forward ? Math.min(currentIndex + 1, allrepository.length - 1) : Math.max(currentIndex - 1, 0)

        setCurrentIndex(newIndex)

        const newOffset = newIndex * ITEM_WIDTH

        flatListRef.current.scrollToOffset({
            offset: newOffset,
            animated: true,
        })
    }
    if (!single) {
        return (
            <View style={[styles.container, !isMobile && { paddingBottom: 43 }]}>
                <TouchableOpacity style={styles.blockHeader} onPress={handle_category} disabled={true}>
                    <View key={item?._id} style={[styles.namesCategory, { opacity: isCategoryBlocked ? 0.5 : 1 }]}>
                        {isCategoryBlocked}
                        {item?.category_name && (
                            <View
                                style={[
                                    styles.containerCategoryNameBis,
                                    {
                                        marginBottom: item?.description ? 4 : 0,
                                    },
                                    !isMobile && { marginBottom: 10 },
                                ]}
                            >
                                <View style={styles.containerCategoryName}>
                                    <Text style={[{ ...styles.categoryName }, !isMobile && { fontSize: 28 }]}>{item?.category_name} </Text>
                                    {isCategoryBlocked && <EvilIcons name='lock' size={30} color={theme.colors.colorLocked} />}
                                </View>
                            </View>
                        )}

                        {item?.description && (
                            <Text style={[styles.categoryDescription, !isMobile && { marginBottom: 4 }]} numberOfLines={3}>
                                {item?.description}
                            </Text>
                        )}
                    </View>
                </TouchableOpacity>

                <View>
                    <Animated.FlatList
                        ref={flatListRef}
                        data={allrepository}
                        onScroll={onScroll}
                        keyExtractor={(item) => item?._id}
                        horizontal={true}
                        showsHorizontalScrollIndicator={false}
                        renderItem={({ item }) => (
                            <CourseItem
                                item={item}
                                category_blocked={isCategoryBlocked}
                                array_cursos={allrepository}
                                horizontal={true}
                                isMobile={isMobile}
                            />
                        )}
                        scrollEventThrottle={16}
                    />
                    {isWeb && allrepository.length > 1 && (
                        <>
                            {/* Flecha izquierda */}
                            {!atStart && (
                                <TouchableOpacity
                                    onPress={() => moveCarrousell(false)}
                                    style={{
                                        position: 'absolute',
                                        left: 16,
                                        top: '50%',
                                        transform: [{ translateY: -20 }],
                                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                        width: 40,
                                        height: 40,
                                        borderRadius: 20,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        zIndex: 30,
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                    }}
                                    onMouseEnter={(e) => {
                                        if (isWeb) e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.8)'
                                    }}
                                    onMouseLeave={(e) => {
                                        if (isWeb) e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.5)'
                                    }}
                                >
                                    <Ionicons name='chevron-back' size={24} color='white' />
                                </TouchableOpacity>
                            )}

                            {/* Flecha derecha */}
                            {!atEnd && (
                                <TouchableOpacity
                                    onPress={() => moveCarrousell(true)}
                                    style={{
                                        position: 'absolute',
                                        right: 16,
                                        top: '50%',
                                        transform: [{ translateY: -20 }],
                                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                        width: 40,
                                        height: 40,
                                        borderRadius: 20,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        zIndex: 1,
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                    }}
                                    onMouseEnter={(e) => {
                                        if (isWeb) e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.8)'
                                    }}
                                    onMouseLeave={(e) => {
                                        if (isWeb) e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.5)'
                                    }}
                                >
                                    <Ionicons name='chevron-forward' size={24} color='white' />
                                </TouchableOpacity>
                            )}
                        </>
                    )}
                </View>
            </View>
        )
    } else {
        return (
            <ScrollView showsVerticalScrollIndicator={false}>
                <View style={[!isMobile && { maxWidth: 1032 }]}>
                    <View style={[styles.containerCategoryName, { marginTop: 12 }, !isMobile && { alignItems: 'flex-start' }]}>
                        {data.cover_image && (
                            <Image
                                source={{ uri: data.cover_image ? data.cover_image : placeholderGeneral }}
                                style={[styles.imageHeaderList, !isMobile && { width: 280, marginEnd: 20, borderRadius: 16 }]}
                            />
                        )}
                        <View style={{ flex: 1 }}>
                            {data.category_name && (
                                <Text style={[styles.categoryNameBis, !isMobile && { fontSize: 36 }, isMobile && { marginStart: 12 }]}>
                                    {data.category_name}
                                </Text>
                            )}
                            {!isMobile && (
                                <View style={{ flex: 1 }}>
                                    {data.description.length > 140 && (
                                        <RenderHTML
                                            source={{ html: isExpanded ? data.description : `${data.description.slice(0, 140)}...` }}
                                            baseStyle={{
                                                fontSize: 16,
                                                fontWeight: 'normal',
                                                color: theme.colors.textSecondary,
                                                marginTop: 4,
                                            }}
                                            contentWidth={winWidth}
                                        />
                                    )}
                                    {data.description.length <= 140 && (
                                        <RenderHTML
                                            source={{ html: data.description }}
                                            baseStyle={{
                                                fontSize: 16,
                                                fontWeight: 'normal',
                                                color: theme.colors.textSecondary,
                                                marginTop: 4,
                                            }}
                                            contentWidth={winWidth}
                                        />
                                    )}
                                    {showReadMore && (
                                        <TouchableOpacity onPress={toggleExpanded}>
                                            <Text style={styles.seeMoreText}>{isExpanded ? languageFile.see_less : languageFile.see_more}</Text>
                                        </TouchableOpacity>
                                    )}
                                </View>
                            )}
                        </View>
                    </View>
                    <View style={[styles.spacer, !isMobile && { height: 20 }]}></View>
                    {isMobile && (
                        <View style={{}}>
                            {data.description.length > 140 && (
                                <RenderHTML
                                    source={{ html: isExpanded ? data.description : `${data.description.slice(0, 140)}...` }}
                                    baseStyle={styles.categoryDescriptionList}
                                    contentWidth={winWidth}
                                />
                            )}
                            {data.description.length <= 140 && (
                                <RenderHTML source={{ html: data.description }} baseStyle={styles.categoryDescriptionList} contentWidth={winWidth} />
                            )}
                            {showReadMore && (
                                <TouchableOpacity onPress={toggleExpanded}>
                                    <Text style={styles.seeMoreText}>{isExpanded ? languageFile.see_less : languageFile.see_more}</Text>
                                </TouchableOpacity>
                            )}
                        </View>
                    )}
                    {!isMobile && (
                        <Text
                            style={{
                                fontSize: 24,
                                fontWeight: 'bold',
                                paddingTop: 16,
                                borderTopColor: theme.colors.lightGray,
                                borderTopWidth: 1,
                                marginBottom: 16,
                                marginHorizontal: 0,
                            }}
                        >
                            Cursos
                        </Text>
                    )}
                    <FlatList
                        data={allrepository}
                        keyExtractor={(item) => item?._id}
                        horizontal={false}
                        showsHorizontalScrollIndicator={false}
                        renderItem={({ item }) => (
                            <CourseItem item={item} category_blocked={isCategoryBlocked} array_cursos={allrepository} isMobile={isMobile} />
                        )}
                    />
                </View>
            </ScrollView>
        )
    }
}

export default CategoryItem
